/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TagEnum {
    Locking = 'LOCKING',
    Unlocking = 'UNLOCKING',
    LightReset = 'LIGHT_RESET',
    FullReset = 'FULL_RESET',
    Reboot = 'REBOOT',
    Locked = 'LOCKED',
    Unlocked = 'UNLOCKED'
}

export function TagEnumFromJSON(json: any): TagEnum {
    return TagEnumFromJSONTyped(json, false);
}

export function TagEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagEnum {
    return json as TagEnum;
}

export function TagEnumToJSON(value?: TagEnum | null): any {
    return value as any;
}

